export default __webpack_public_path__ + "static/media/Group 6515@3x.37d16a74.png";